import { TFunction } from "i18next";

/**
 * Returns a human-readable description for an OAuth scope using i18n.
 * Falls back to the scope name itself if no translation is found.
 */
export function describeScope(
  scope: string,
  t: TFunction
): { name: string; description: string } {
  const nameKey = `scopes-names.${scope}`;
  const descKey = `scopes.${scope}`;

  return {
    name: t(nameKey) === nameKey ? scope : t(nameKey),
    description: t(descKey) === descKey ? "" : t(descKey),
  };
}
